import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

/**
 * Skeleton stand-in for compact ListCard rows while a filter-driven search loads.
 */
export default function ListLoadingState({ rows = 8 }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box data-testid="list-loading-state" sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
      {Array.from({ length: rows }).map((_, index) => (
        <Box
          key={index}
          sx={{
            marginBottom: "21px",
            background: isDark ? "#1E1E1E" : "#FFFFFF",
            border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(88, 89, 91, 0.2)"}`,
            borderRadius: "10px",
            padding: "20px 24px",
            width: "100%",
            maxWidth: 943,
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <Skeleton variant="rounded" width={59} height={59} sx={{ flexShrink: 0, borderRadius: 2 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="42%" height={26} />
            <Skeleton variant="text" width="88%" height={18} sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width="70%" height={18} />
            <Box sx={{ display: "flex", gap: 1, mt: 1.25 }}>
              <Skeleton variant="rounded" width={88} height={24} sx={{ borderRadius: 999 }} />
              <Skeleton variant="rounded" width={110} height={24} sx={{ borderRadius: 999 }} />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
